import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "auth-dropdown flex justify-content-right align-items-right lg:static"
};
const _hoisted_2 = { key: 0 };
const _hoisted_3 = { key: 1 };
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("div", { class: "font-semibold" }, [
    /*#__PURE__*/ _createElementVNode("i", { class: "pi pi-wrench" }),
    /*#__PURE__*/ _createTextVNode(" Administration ")
], -1);
const _hoisted_5 = [
    _hoisted_4
];
import 'primeicons/primeicons.css';
import useAuthStore from '@/store/auth.store';
import router from "@/router";
export default /*#__PURE__*/ _defineComponent({
    __name: 'AdminMenuComponent',
    setup(__props) {
        const authStore = useAuthStore();
        const adminOptions = [
            { name: 'User Management', url: '/users' },
            { name: 'Subscription Management', url: '/admin/subscription' },
        ];
        var selectedAction = '';
        function adminNavChanged(event) {
            router.push(event.value);
        }
        return (_ctx, _cache) => {
            const _component_DropDown = _resolveComponent("DropDown");
            return (_unref(authStore).isActivelyLoggedIn)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(_component_DropDown, {
                        modelValue: _unref(selectedAction),
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (_isRef(selectedAction) ? (selectedAction).value = $event : selectedAction = $event)),
                        options: adminOptions,
                        optionLabel: "name",
                        optionValue: "url",
                        filter: false,
                        showClear: false,
                        style: { "border": "none" },
                        onChange: adminNavChanged
                    }, {
                        value: _withCtx((slotProps) => [
                            (slotProps.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(slotProps.value.name), 1))
                                : (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
                        ]),
                        _: 1
                    }, 8, ["modelValue"])
                ]))
                : _createCommentVNode("", true);
        };
    }
});
